import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const calendarV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Calendar element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'calendar'>): void => {
    const calendarProps = props;

    if (calendarProps?.style?.general?.titles && !calendarProps?.content?.title?.iconColor) {
      const currentColor = calendarProps.style.general.titles.color1;
      calendarProps.content = {
        ...calendarProps.content,
        title: {
          ...calendarProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
